// extracted by mini-css-extract-plugin
module.exports = {"parameters":"o"};